import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import Geosuggest from 'react-geosuggest';

import './Games.css';
import { EventViewSplitPane } from './Event'
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, EmptyState, LoadingState } from './Common';
import { GameSummary } from '../pages/GAME';

export default class Games extends Component {
    constructor(p) {
        super(p)
        this.state = {
            activeTab: "Upcoming Games",
            userTabs: ["Upcoming Games", "Past Games"]
        }
    }

    static PastGames = PastGames;
    static UpcomingGames = UpcomingGames;
    static UpcomingGameList = UpcomingGameList;

    render() {
        const { teams, league } = this.props;
        return (
            <div className="default-view" style={{ backgroundColor: "#fff",  paddingBottom: "20px" }}>
                <div className="view-with-tabs">
                    <div className="view-with-tabs-head">
                        {
                            this.state.userTabs.map((item, i) => {
                                return (
                                    <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ activeTab: item })}>{item}</div>
                                )
                            })
                        }
                    </div>
                    <div className="view-with-tabs-body">
                        <UpcomingGames teams={teams} league={league} activeTab={this.state.activeTab} />
                        <PastGames teams={teams} league={league} activeTab={this.state.activeTab} />
                    </div>
                </div>
            </div>
        );
    }
}

class UpcomingGames extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            games: [],
            filter: "All"
        }
    }

    static UpcomingGameList = UpcomingGameList;
    static UpcomingGameItem = UpcomingGameItem;

    componentDidMount() {
        FakeData.mountState("up-games", true)
        this._isMounted = true;
        this.getGames();
    }

    componentWillUnmount(){
        this._isMounted = false;
        FakeData.mountState("up-games", false)
    }


    getGames = () => {
        const _that = this;
        const dateTo = {
            isPast: false,
            isLeague: !this.props.league ? false : true,
            leagueId: !this.props.league ? 0 : this.props.league,
            teams: this.props.teams,
            user: FakeData.getData("yoo")
        }

        if(!this._isMounted){
            return;
        }

        FakeData.post("/getProfileGames.php?auth0", dateTo, {
            success(res) {
                if (!FakeData.isMounted("up-games")) {
                    return
                }
                _that.setState({ games: res, isLoading: false });
            },
            error(err) {
                FakeData.alert("Couldn't reach server!");
                _that.setState({ games: [], isLoading: false });
            }
        })
    }

    getMonths = () => {
        const { isLoading, games } = this.state;
        const list = [];
        games.forEach((item, i) => {
            if (!FakeData.inArray(item.date_month_tag, list)) {
                list.push(item.date_month_tag);
            }
        })

        return list;
    }

    getGamesForMonth = (month) => {
        const { isLoading, games } = this.state;
        const list = games.filter((item) => {
            return item.date_month_tag === month;
        })

        return list;
    }

    getLeagues = () => {
        const { isLoading, games } = this.state;
        const list = ["All"];
        games.forEach((item, i) => {
            if (!FakeData.inArray(item.league_tag, list)) {
                list.push(item.league_tag);
            }
        })

        return list;
    }

    render = () => {
        const { isLoading, games, filter } = this.state;
        const { activeTab } = this.props;

        if (activeTab !== "Upcoming Games") {
            return null;
        }

        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text={"Loading"} />
            )
        }

        if (games.length === 0) {
            return (
                <EmptyState isShown={true} text="No games were found!" icon="thumbs_up_down" />
            )
        }

        return (
            <div style={{ width: "100%" }}>
                <div className="up-gm-filter">
                    <span>Select League</span>
                    <select value={filter} onChange={(e) => {
                        const val = e.currentTarget.value;
                        this.setState({ filter: val });
                    }}>
                        {
                            this.getLeagues().map((item, i) => {
                                return (
                                    <option key={i} value={item}>{item}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div>
                    {
                        this.getMonths().map((item, i) => {
                            return (
                                <UpcomingGameList embed={false} filterable={true} filter={filter} style={{}} item={item} games={this.getGamesForMonth(item)} key={i} />
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

export const UpcomingGameList = ({ games, item, style, filterable, filter, embed, children }) => {
    if (embed) {
        return (
            <div className="up-gm-item" style={{ ...style }}>
                <span>{item}</span>
                <div className="up-gm-item-list">
                    {children}
                </div>
            </div>
        )
    }
    return (
        <div className="up-gm-item" style={{ ...style }}>
            <span>{item}</span>
            <div className="up-gm-item-list">
                {
                    games.map((game, g) => {
                        if (filterable && (filter !== "All" && game.league_tag !== filter)) {
                            return null;
                        }

                        return (
                            <UpcomingGameItem game={game} key={g} />
                        )
                    })
                }
            </div>
        </div>
    )
}

const UpcomingGameItem = (props) => {
    const { game } = props;
    return (
        <Link to={{ pathname: "/game/" + game.id, search: "" }} className="up-gm-list-item">
            <img src={game.teamOne.image} />
            <div className="up-gm-list-item-details">
                <div className="up-gm-list-item-details-team">
                    <span className="up-gm-list-item-details-team-name">{game.teamOne.squad.name != "" ? game.teamOne.squad.name : game.teamOne.name}</span>
                    <span className="up-gm-list-item-details-team-vs">vs</span>
                    <span className="up-gm-list-item-details-team-name">{game.teamTwo.squad.name != "" ? game.teamTwo.squad.name : game.teamTwo.name}</span>
                </div>
                <span className="up-gm-list-item-details-time">{game.time}</span>
            </div>
            <img src={game.teamTwo.image} />
            <img style={{ width: "18px", height: "18px" }} src={game.status === "finished" ? "images/calendar_icon_grn.svg" : "images/calendar_icon_gry.svg"} />
        </Link>
    )
}

class PastGames extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            games: [],
            filter: "All"
        }
    }

    componentDidMount() {
        FakeData.mountState("ps-games", true)
        this._isMounted = true;
        this.getGames();
    }

    componentWillUnmount(){
        FakeData.mountState("ps-games", false)
        this._isMounted = false
    }

    getGames = () => {
        const _that = this;
        const dateTo = {
            isPast: true,
            isLeague: !this.props.league ? false : true,
            leagueId: !this.props.league ? 0 : this.props.league,
            teams: this.props.teams,
            user: FakeData.getData("yoo")
        }

        if(!this._isMounted){
            return;
        }

        FakeData.post("/getProfileGames.php?auth0", dateTo, {
            success(res) {
                if (!FakeData.isMounted("ps-games")) {
                    return
                }
                _that.setState({ games: res, isLoading: false });
            },
            error(err) {
                FakeData.alert("Couldn't reach server!");
                _that.setState({ games: [], isLoading: false });
            }
        })
    }

    getMonths = () => {
        const { isLoading, games } = this.state;
        const list = [];
        games.forEach((item, i) => {
            if (!FakeData.inArray(item.date_month_tag, list)) {
                list.push(item.date_month_tag);
            }
        })

        return list;
    }

    getGamesForMonth = (month) => {
        const { isLoading, games } = this.state;
        const list = games.filter((item) => {
            return item.date_month_tag === month;
        })

        return list;
    }

    getLeagues = () => {
        const { isLoading, games } = this.state;
        const list = ["All"];
        games.forEach((item, i) => {
            if (!FakeData.inArray(item.league_tag, list)) {
                list.push(item.league_tag);
            }
        })

        return list;
    }

    render = () => {
        const { isLoading, games, filter } = this.state;
        const { activeTab } = this.props;

        if (activeTab !== "Past Games") {
            return null;
        }

        if (isLoading) {
            return (
                <LoadingState isShown={isLoading} text={"Loading"} />
            )
        }

        if (games.length === 0) {
            return (
                <EmptyState isShown={true} text="No games were found!" icon="thumbs_up_down" />
            )
        }

        return (
            <div style={{ width: "100%" }}>
                <div className="up-gm-filter">
                    <span>Select League</span>
                    <select value={filter} onChange={(e) => {
                        const val = e.currentTarget.value;
                        this.setState({ filter: val });
                    }}>
                        {
                            this.getLeagues().map((item, i) => {
                                return (
                                    <option key={i} value={item}>{item}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div>
                    {
                        this.getMonths().map((item, i) => {
                            return (
                                <PastGameList filterable={true} filter={filter} style={{}} item={item} games={this.getGamesForMonth(item)} key={i} />
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

export const PastGameList = ({ games, item, style, filterable, filter }) => {
    return (
        <div className="up-gm-item" style={{ ...style }}>
            <span>{item}</span>
            <div className="up-gm-item-list">
                {
                    games.map((game, g) => {
                        if (filterable && (filter !== "All" && game.league_tag !== filter)) {
                            return null;
                        }

                        return (
                            <PastGameItem game={game} key={g} />
                        )
                    })
                }
            </div>
        </div>
    )
}

class PastGameItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isShowingSummary: false,
            game: { id: null },
            posts: [],
            gmc: {},
            summary: [],
            stats: {},
            textSummary: []
        }
    }

    componentDidMount() {
        FakeData.mountState("game" + this.props.game.id, true);
        this._isMounted = true;
        this.getGame();
        this.getGamePosts();
    }


    componentWillMount() {
        FakeData.mountState("game" + this.props.game.id, false)
        this._isMounted = false;
    }


    getGame() {
        const _that = this
        const User = FakeData.getData("yoo")
        const dataTo = {
            userId: User.id,
            gameId: this.props.game.id
        }

        if(!this._isMounted){
            return;
        }

        FakeData.post('/getPublicGame.php?auth0', dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("game" + this.props.game.id)) {
                    return
                }
                const data = res
                _that.setState({
                    game: data.core,
                    gmc: data.gmc,
                    summary: data.summary,
                    stats: data.stats,
                    textSummary: data.textSummary,
                    isLoading:false
                });

                setTimeout(() => {
                    _that.getGame()
                }, 3000)
            }),
            error: ((err) => {
                setTimeout(() => {
                    _that.getGame()
                }, 3000)
            })
        })
    }

    getGamePosts() {
        const _that = this
        const User = FakeData.getData("yoo")
        const dataTo = {
            userId: User.id,
            gameId: this.props.game.id
        }

        if(!this._isMounted){
            return;
        }

        FakeData.post('/getPublicGamePosts.php?auth0', dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("game" + this.props.game.id)) {
                    return
                }
                const data = res
                _that.setState({
                    posts: data
                });

                setTimeout(() => {
                    _that.getGamePosts()
                }, 1000)
            }),
            error: ((err) => {
                setTimeout(() => {
                    _that.getGamePosts()
                }, 1000)
            })
        })
    }

    render = () => {
        const { game } = this.props;
        const { isLoading, isShowingSummary } = this.state
        return (
            <div className="ps-gm-item">
                <div className="ps-gm-item-head" style={{borderBottom:isShowingSummary?"0.3px solid #ccc":"none", cursor:"pointer", marginBottom:"10px"}} onClick={()=>{
                    this.setState({isShowingSummary:!isShowingSummary})
                }}>
                    <div className="ps-gm-item-head-team">
                        <img src={game.teamTwo.image} />
                        <span>{game.teamOne.squad.name != "" ? game.teamOne.squad.name : game.teamOne.name}</span>
                    </div>
                    <div className="ps-gm-item-head-score">
                        <LoadingState style={{ padding: "0.1vw 0px" }} spinnerStyle={{ width: "40px", height: "40px" }} isShown={isLoading} />
                        {!isLoading && this.state.game.id!==null &&
                            <span>{FakeData.listify(this.state.gmc.teamOneGoals).length} - {FakeData.listify(this.state.gmc.teamTwoGoals).length}</span>
                        }
                        {!isLoading && this.state.game.id===null &&
                            <span>0 - 0</span>
                        }
                    </div>
                    <div className="ps-gm-item-head-team">
                        <span>{game.teamTwo.squad.name != "" ? game.teamTwo.squad.name : game.teamTwo.name}</span>
                        <img src={game.teamTwo.image} />
                    </div>
                </div>
                {isShowingSummary &&
                    <div className="ps-gm-item-body">
                        <GameSummary textSummary={this.state.textSummary} isEmbed={true} summary={this.state.summary} user={FakeData.getData("yoo")} game={this.state.game} uniq={"Summary"} />
                    </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Games.js